import classNames, { Value as ClassValue } from "classnames";
import React from "react";
import { NoWrapLabel } from "./NoWrapLabel";

export function Horizontal(props: {
  children: React.ReactNode;
  label?: React.ReactNode;
  isRequired?: boolean;
  fieldId?: string;
  shouldNotPadLabel?: true;
  theme?: { container?: React.CSSProperties; label?: React.CSSProperties };
  className?: ClassValue;
}) {
  return (
    <div
      className={classNames("field is-horizontal", props.className)}
      style={props.theme?.container}
    >
      <div
        className={classNames("field-label", {
          "is-normal": props.shouldNotPadLabel !== true,
        })}
      >
        {props.label !== undefined && (
          <NoWrapLabel
            isRequired={props.isRequired}
            name={props.label}
            labelFor={props.fieldId}
            style={props.theme?.label}
          />
        )}
      </div>
      <div className="field-body">{props.children}</div>
    </div>
  );
}
